import React from 'react';
import styled from 'styled-components/macro';

import MuiModal from '../_common/Modal';
import UserModalLayout from './UserModalLayoutContainer';
import { UserModalProps } from './UserModalContainer';

const Modal = styled(MuiModal)`
  @media (max-width: 599px) {
    .dialog-paper > button svg {
      /* close modal button */
      color: #fff;
    }
  }
`;

const CreateUserModal = React.memo((props: UserModalProps) => {
  const { closeModalUser, isOpen } = props;

  return (
    <Modal// `disableBackdropClick` is removed by codemod.
// You can find more details about this breaking change in [the migration guide](https://mui.com/material-ui/migration/v5-component-changes/#modal)
 isOpen={isOpen} onClose={closeModalUser}>
      <UserModalLayout />
    </Modal>
  );
});

export default CreateUserModal;
